<style scoped>
.gray-bg {
  background-color: rgba(0, 0, 0, 0.12) !important;
}
</style>

<template>
  <v-card class="mb-6">
    <v-card-title :class="{ 'gray-bg': titleGray }">
      <slot name="title">{{ title }}</slot>
      <v-spacer />
      <slot name="top-action">
        <anchor-tooltip-btn
          v-if="addAction"
          small
          left
          is-icon
          color="primary"
          :icon="addIcon"
          :tooltip="addTooltip"
          @click="$emit('add')"
        />
      </slot>
    </v-card-title>
    <v-divider />
    <v-card-text>
      <slot />
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    addAction: Boolean,
    addIcon: {
      type: String,
      default: 'mdi-plus',
    },
    addTooltip: {
      type: String,
      default: 'Add',
    },
    title: String,
    titleBold: Boolean,
    titleGray: Boolean,
  },
  computed: {
    classForTitle: vm => {
      let val = vm.titleBold ? '' : 'font-weight-regular';
      if (vm.titleClass) {
        val += ` ${vm.titleClass}`;
      }
      return val;
    },
  },
};
</script>
